export function clearSessionFailure(actionContext) {
    actionContext.dispatch('CLEAR_SESSION_FAILURE');
}

export function setLoginMode(actionContext, mode) {
    actionContext.dispatch('SET_LOGIN_MODE', mode);
}
